import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';
import { OperatorInputOperatorFragment } from '../../fields/OperatorInput/index';
import { LeaseInputLeaseFragment } from '../../fields/LeaseInput/index';

const TicketStatus = gql`
  fragment TicketStatus on TicketNumber {
    id
    number
    can_destroy
    created_by {
      id
      fullname
    }
    created_at {
      date
      iso8601
    }
    ticket {
      id
    }
    totalManHours: total_man_hours {
      to_string
      totalSeconds: total_seconds
    }
  }
`;

/* TODO: take status in as parameter
 * TODO: Use ($assignedStatus:  TicketNumberAssignedTypes) */
export const GetAllTicketNumbersQuery = gql`
  query GetAllTicketNumbers{
    all_ticket_numbers(assigned: unassigned, created_date_order: asc) {
      edges {
        node {
          ...TicketStatus
        }
      }
    }
  }
  ${TicketStatus}
`;

const marshallData = ({ data, ownProps }) => {
  const allTicketNumbers = querySelector(data, '$.all_ticket_numbers.edges[*].node', []);
  return {
    ...ownProps,
    data,
    allTicketNumbers,
  };
};

const queryData = graphql(GetAllTicketNumbersQuery, {
  props: marshallData,
  options: { fetchPolicy: 'network-only' },
});

export const queryAllTicketNumbersGQL = compose(
  queryData,
  queryMetaHandler,
  omitProps(['data']),
);

export const TicketNumberStatusFragment = gql`
  fragment TicketNumberStatus on TicketNumber {
    id
    number
    district {
      id
      name
    }
    department {
      id
      name
    }
    operator {
      id
      name
      lookup {
        ...OperatorInputOperatorLookup
      }
    }
    lease {
      id
      name
      lookup {
        ...LeaseInputLease
      }
    }
    jobNumber: job_number {
      id
      number
      hasJob: has_job
    }
  }
  ${OperatorInputOperatorFragment}
  ${LeaseInputLeaseFragment}
`;

const GetTicketNumberTimeEntriesByUserAndDayQuery = gql`
  query GetTicketNumberTimeEntriesByUserAndDay($ticketNumberId : Int!) {
    ticket_number(id: $ticketNumberId) {
      ...TicketNumberStatus
      user_daily_time_entry_groups {
        time_entry_group {
          interval {
            day_of_week
            day
            month
            iso8601
          }
          total_hours {
            to_string
          }
          daily_time_entries {
            date {
              display
            }
            total_hours {
              to_string
            }
          }
        }
        edges {
          node {
            user {
              id
              firstname
              lastname
            }
            user_worked_hours_total: worked_hours {
              to_string
            }
            daily_time_entries {
              timeEntries: time_entries {
                paidPerDiem: paid_per_diem
              }
              date {
                iso8601
              }
              worked_hours {
               to_string
              }
            }
          }
        }
      }
    }
  }
  ${TicketNumberStatusFragment}
`;

const marshallTicketNumberData = ({ data, ownProps }) => {
  const [ticketNumberData] = querySelector(data, '$.ticket_number', []);

  return {
    ...ownProps,
    data,
    ticketNumberData,
  };
};

const queryTicketNumberData = graphql(GetTicketNumberTimeEntriesByUserAndDayQuery, {
  props: marshallTicketNumberData,
  options: { fetchPolicy: 'network-only' },
});

export const queryTicketNumberGQL = compose(
  queryTicketNumberData,
  queryMetaHandler,
  omitProps(['data']),
);
